import { ValidaCertificadoAPI } from "@/api/validaCertificado.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { CertificadoInclusaoRegistro } from "@/models/certificadoInclusaoRegistro";

const validaCertificadoApi = new ValidaCertificadoAPI();

const validaCertificado = (
  codigoValidador: string
): AxiosObservable<CertificadoInclusaoRegistro> => {
  return validaCertificadoApi.validaCertificado(codigoValidador);
};

export default {
  validaCertificado
};
